<template>
  <div class="m-home">
    <!-- banner -->
    <MSwiper v-if="swiperList && swiperList.length>0" :swiperLength="swiperList.length" :swiperType="1">
      <!-- <img v-for="(item, index) in swiperList" :key="index" :slot="`swiper-${index}`" :data-url="item.targetUrl" :src="item.imageUrl" alt=""> -->
      <div v-for="(item, index) in swiperList" :key="index" :slot="`swiper-${index}`" :data-url="item.targetUrl" 
          :style="{width:'100%',height:'4.5rem',background:'url('+item.imageUrl+') no-repeat','background-position':'center top','background-size':'cover'}"></div>
    </MSwiper>
    <!-- 导航 -->
    <div class="m-home-nav">
      <div @click="changePage(item.value)" class="nav-item" v-for="(item, index) in navList" :key="index">
        <div :style="'background:' + item.bgColor" class="nav-icon">
          <img :src="item.imgUrl" alt="">
        </div>
        <div class="nav-title">{{item.title}}</div>
      </div>
    </div>
    <!-- 植根教育 -->
    <div class="m-home-edu">
      <div class="module-title">植根教育	服务教育</div>
      <div class="module-desc">让更多的孩子得到更好的教育<br/>让更多的教师得到更好的提高<br/>让更多的学校得到更好的发展</div>
      <div class="edu-content">
        <div class="edu-line1">
          <div class="edu-item">
            <img class="edu-icon" src="../../assets/images/mImg/home/edu_1.png" alt="">
            <div class="edu-title">20+年<br/>教育产业经验</div>
          </div>
          <div class="edu-item">
            <img class="edu-icon" src="../../assets/images/mImg/home/edu_2.png" alt="">
            <div class="edu-title">200+<br/>业务覆盖城市</div>
          </div>
        </div>
        <div class="edu-line2">
          <div class="edu-item">
            <img class="edu-icon" src="../../assets/images/mImg/home/edu_3.png" alt="">
            <div class="edu-title">4000+<br/>合作学校</div>
          </div>
          <div class="edu-item">
            <img class="edu-icon" src="../../assets/images/mImg/home/edu_4.png" alt="">
            <div class="edu-title">300000+<br/>教师受益</div>
          </div>
          <div class="edu-item">
            <img class="edu-icon" src="../../assets/images/mImg/home/edu_5.png" alt="">
            <div class="edu-title">3000000+<br/>学生受益</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 公益 -->
    <div class="m-home-charity">
      <div class="module-title">公益事业</div>
      <div class="module-desc">我们一直在行动</div>
      <div class="charity-swiper-wrap">
        <MSwiper :swiperLength="charityList.length" :swiperType="2">
          <div class="charity-item" v-for="(item, index) in charityList" :key="index" :slot="`swiper-${index}`">
            <img class="charity-img" :src="item.imgUrl" alt="">
            <div class="charity-content" :class="'charity-content-' + index">
              <div class="charity-icon-wrap"><img class="charity-icon" :src="item.iconUrl" alt=""></div>
              <p class="charity-title">{{item.title}}</p>
              <div class="charity-desc">{{item.desc}}</div>
            </div>
          </div>
        </MSwiper>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="m-home-solution">
      <div class="module-title">智慧教育解决方案</div>
      <div class="module-desc">推动教育优质均衡及高质量发展</div>
      <div class="m-home-solution-content">
        <div class="solution-item" v-for="(item, index) in solutionLIst" :key="index">
          <img v-if="index%2===0" class="solution-img" :src="item.imgUrl" alt="">
          <div class="solution-text" v-html="item.text"></div>
          <img v-if="index%2===1" class="solution-img" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 合作案例 -->
    <div class="m-home-case">
      <div class="module-title">合作案例</div>
      <div class="module-desc">赋能学校	赋能教师</div>
      <div class="m-home-case-swiper">
        <MSwiper :swiperLength="10" :swiperType="3">
          <img :slot="'swiper-0'" class="case-item" src="../../assets/images/homeCase/case_1.png" alt="">
          <img :slot="'swiper-1'" class="case-item" src="../../assets/images/homeCase/case_2.png" alt="">
          <img :slot="'swiper-2'" class="case-item" src="../../assets/images/homeCase/case_3.png" alt="">
          <img :slot="'swiper-3'" class="case-item" src="../../assets/images/homeCase/case_4.png" alt="">
          <img :slot="'swiper-4'" class="case-item" src="../../assets/images/homeCase/case_5.png" alt="">
          <img :slot="'swiper-5'" class="case-item" src="../../assets/images/homeCase/case_6.png" alt="">
          <img :slot="'swiper-6'" class="case-item" src="../../assets/images/homeCase/case_7.png" alt="">
          <img :slot="'swiper-7'" class="case-item" src="../../assets/images/homeCase/case_8.png" alt="">
          <img :slot="'swiper-8'" class="case-item" src="../../assets/images/homeCase/case_9.png" alt="">
          <img :slot="'swiper-9'" class="case-item" src="../../assets/images/homeCase/case_10.png" alt="">
        </MSwiper>
      </div>
    </div>
    <MRightNav></MRightNav>
  </div>
</template>
<script>
const jsonp = require("jsonp");
import MSwiper from './components/MSwiper'
import scrollreveal from 'scrollreveal'
import MRightNav from './components/MRightNav.vue'
export default {
  data() {
    return {
      swiperList: [],
      navList: [{
        title: '解决方案',
        imgUrl: require('../../assets/images/mImg/home/nav_solution.png'),
        bgColor: '#72D0FE',
        value: 'solution'
      }, {
        title: '合作案例',
        imgUrl: require('../../assets/images/mImg/home/nav_case.png'),
        bgColor: '#CD69C4',
        value: 'case'
      }, {
        title: '合作支持',
        imgUrl: require('../../assets/images/mImg/home/nav_support.png'),
        bgColor: '#FE5D5D',
        value: 'support'
      }, {
        title: '关于我们',
        imgUrl: require('../../assets/images/mImg/home/nav_about.png'),
        bgColor: '#FCAB57',
        value: 'about'
      }],
      charityList: [{
        imgUrl: require('../../assets/images/mImg/home/chrity_1.png'),
        iconUrl: require('../../assets/images/charity_11.png'),
        title: '外交部驻外随居子女远程教育',
        desc: '自2011年开始，与外交部干部司签约合作，为200多个中国驻外使领馆（含代表团）的随居子女，提供优质的国内同步学习服务。'
      }, {
        imgUrl: require('../../assets/images/mImg/home/chrity_2.png'),
        iconUrl: require('../../assets/images/charity_22.png'),
        title: '中国华文教育基金会教师讲堂',
        desc: '2013年，与统战部（原国侨办）下属中国华文教育基金会合作，公益服务全球华文学校，8年多以来，服务了90多个国家1500多所华校，先后培训过数十万海外华文教师。'
      }, {
        imgUrl: require('../../assets/images/mImg/home/chrity_3.png'),
        iconUrl: require('../../assets/images/charity_33.png'),
        title: '民盟远程教育烛光行动',
        desc: '2011年，与民盟中央签署远程教育烛光行动公益合作协议。为偏远地区和欠发达地区的教师提供智慧教育平台，有效加强了广大一线教师教育教学能力及综合素质。2016年，启动“民盟远程教育烛光行动-千校计划”，积极推进“互联网+教育”的发展，为深入推进义务教育均衡发展做出更大贡献。'
      }],
      solutionLIst: [{
        imgUrl: require('../../assets/images/mImg/home/solution_1.png'),
        text: '基于“三个课堂”的<br/>区域教育优质均衡解决方案'
      }, {
        imgUrl: require('../../assets/images/mImg/home/solution_2.png'),
        text: '数据驱动下的<br/>智慧课堂精准教学'
      }, {
        imgUrl: require('../../assets/images/mImg/home/solution_3.png'),
        text: '“专递课堂”的<br/>教育均衡解决方案'
      }, {
        imgUrl: require('../../assets/images/mImg/home/solution_4.png'),
        text: '“双减”背景下的<br/>智慧作业解决方案'
      }, {
        imgUrl: require('../../assets/images/mImg/home/solution_5.png'),
        text: '基于“名师课堂”的<br/>教研共同体应用方案'
      }, {
        imgUrl: require('../../assets/images/mImg/home/solution_6.png'),
        text: '基于“名校网络课堂”的<br/>优质教育共建共享解决方案'
      }, {
        imgUrl: require('../../assets/images/mImg/home/solution_7.png'),
        text: '基于考试数据的<br/>教学评价及改进方案'
      }]
    }
  },
  mounted() {
    this.getSwiperList()
    this.$nextTick(() => {
      let that = this
      setTimeout(() => {
        that.setAnimation()
      }, 100)
    })
  },
  methods: {
    getSwiperList() {
      jsonp(`${this.$etturl}banners/list.do?r=${Math.random()}`, {
        r: Math.random()
      }, (err, res) => {
        if (!err) {
          this.swiperList = res.data
          // if (this.swiperList.length <=1) {
          //   this.swiperOptions.loop = false
          // }
        }
      })
    },
    changePage(type) {
      this.$emit('changePages', type)
    },
    // 将图片地址替换为https
    // handleUrl(url) {
    //   let urlArr = url.split('://')
    //   let newUrl = ''
    //   if(urlArr[0] == "http"){
    //     newUrl = "https://" + urlArr[1]
    //   } else {
    //     newUrl = url
    //   }
    //   return newUrl
    // },
    // 动画
    setAnimation() {
      scrollreveal().reveal('.module-title', {
        duration: 1500, //动画的时长
        origin: 'bottom', //动画开始的位置，'bottom', 'left', 'top', 'right'
        reset: true, //回滚的时候是否再次触发动画
        mobile: true, //在移动端是否使用动画
        distance: '40px', //滚动的距离，单位可以用%，rem等
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.module-desc', {
        duration: 1500,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.edu-item .edu-icon', {
        duration: 1500,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.edu-item .edu-title', {
        duration: 1500,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance: '40px',
        easing: 'ease-in-out'
      });
      // scrollreveal().reveal('.charity-content-0 .charity-title', {
      //   duration: 1500,
      //   origin: 'bottom',
      //   reset: true,
      //   mobile: true,
      //   distance: '40px',
      //   easing: 'ease-in-out'
      // });
      // scrollreveal().reveal('.charity-content-0 .charity-desc', {
      //   duration: 1500,
      //   origin: 'bottom',
      //   reset: true,
      //   mobile: true,
      //   distance: '40px',
      //   easing: 'ease-in-out'
      // });
      scrollreveal().reveal('.m-home-solution .solution-img', {
        duration: 1500,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance:'40px',
        easing: 'ease-in-out'
      });
      scrollreveal().reveal('.m-home-solution .solution-text', {
        duration: 1500,
        origin: 'bottom',
        reset: true,
        mobile: true,
        distance:'40px',
        easing: 'ease-in-out'
      });
    }
  },
  components: {
    MSwiper,
    MRightNav
  }
}
</script>
<style lang="scss" scoped>
.m-home {
  width: 100%;
  .m-home-nav {
    width: 100%;
    height: 2.02rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .8rem;
    background: #FFFFFF;
    .nav-item {
      // width: .86rem;
      text-align: center;
      font-size: .29rem;
      font-weight: 600;
      color: #393332;
      .nav-icon {
        width: .8rem;
        height: .8rem;
        border-radius: 50%;
        margin: 0 auto;
        margin-bottom: .16rem;
        img {
          width: .45rem;
          height: .45rem;
          margin-top: .18rem;
        }
      }
    }
  }
  .module-title {
    font-size: .5rem;
    font-weight: 500;
    color: #393332;
    line-height: .48rem;
    text-align: center;
  }
  .module-desc {
    font-size: .33rem;
    font-weight: 400;
    color: #727171;
    line-height: .42rem;
    margin-top: .28rem;
    text-align: center;
  }
  .m-home-edu {
    margin-top: 1.2rem;
    .edu-content {
      font-size: .29rem;
      font-weight: 400;
      color: #393332;
      line-height: .32rem;
      text-align: center;
      padding: 0 .32rem;
      margin-top: .64rem;
      img {
        width: .96rem;
        height: .96rem;
      }
      .edu-line1 {
        display: flex;
        justify-content: space-evenly;
      }
      .edu-line2 {
        display: flex;
        justify-content: space-around;
        margin-top: .8rem;
      }
    }
  }
  .m-home-charity {
    margin-top: 1.76rem;
    .charity-swiper-wrap {
      // padding: 0 .54rem 0 .66rem;
      margin-top: .58rem;
      .charity-item {
        width: calc(6.4rem - .14rem);
        background: #FFFFFF;
        border-radius: .15rem;
        box-shadow: .06rem .07rem .1rem 0px rgba(61, 61, 61, 0.25);
        margin: 0 auto;
        margin-bottom: .42rem;
        .charity-img {
          width: 100%;
          height: 4.6rem;
        }
        .charity-content {
          height: 5.62rem;
          .charity-icon-wrap {
            width: .92rem;
            height: .92rem;
            text-align: center;
            padding-top: .16rem;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 0px .03rem .04rem 0px rgba(2, 48, 95, 0.35);
            border-radius: 50%;
            margin: 0 auto;
            margin-top: -.4rem;
            position: relative;
            z-index: 1;
            .charity-icon {
              width: .6rem;
              height: .6rem;
              display: block;
              margin: 0 auto;
            }
          }
          .charity-title {
            font-size: .42rem;
            font-weight: 500;
            color: #393332;
            line-height: .42rem;
            text-align: center;
            margin-top: .28rem;
            margin-bottom: .2rem;
          }
          .charity-desc {
            padding: 0 .4rem;
            font-size: .29rem;
            font-weight: 400;
            color: #595757;
            line-height: .42rem;
            text-align: justify;
          }
        }
      }
    }
  }
  .m-home-solution {
    margin-top: 1.8rem;
    .m-home-solution-content {
      margin-top: .48rem;
    }
    .solution-item {
      display: flex;
      justify-content: center;
      .solution-img {
        width: 3.37rem;
        height: 2.12rem;
        display: block;
      }
      .solution-text {
        width: 3.37rem;
        height: 2.12rem;
        font-size: .25rem;
        font-weight: 400;
        color: #595757;
        padding-left: .2rem;
        display: flex;
        align-items: center;
      }
    }
  }
  .m-home-case {
    margin-top: 1.88rem;
    margin-bottom: 2rem;
    .m-home-case-swiper {
      margin-top: .72rem;
      .case-item {
        width: 4.76rem;
        height: 3.54rem;
      }
    }
  }
}
</style>